import { createFileRoute } from '@tanstack/react-router';
import RemindersPage from '@/components/reminders/RemindersPage';

export const Route = createFileRoute('/manage/reminders')({
  component: RemindersPage
});
